<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">

      <EnterprieSidebarMenu :show_menu="false" :show_back_button="false" back_link="enterpriseadminreports"></EnterprieSidebarMenu>

      <nav id="sidebar1" v-if="selectedComponent != 'PathwaysTab'" 
        class="show_back_button"
      >
        <ul class="list-unstyled">
          <li class="" style="cursor: pointer;" @click="backtoPathwayProgress()">
            
              <img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />
              Back
            
          </li>
        </ul>
      </nav>


      <div class="content-wrapper padding-left-165">
        <div class="container-wrapper center ml-2">
            <div class="modal-custom overlay" v-show="showOverlay">
              <div class="loader-img-center">
                <i class="fa fa-spinner fa-spin"></i> Please wait...
              </div>
            </div>
          <iframe id="pdf-frame" style="display: none;"></iframe>

          <div class="row mt-3 mb-3 border-bottom pb-2">
            <div class="col-9 float-left text-left pl-0">
              <div class="h4 text-uppercase">Progress - {{ menteeName }}</div>
            </div>
            <div class="col-3 float-right text-right pr-0" >
              <div v-if="displayFlag == 1" class="margin-t-2 float-right pl-2" @click="shareButtonModal()">
                <img class="cursor-pointer" src="@/assets/Send_Report_Button.svg" alt="MentorMentee" width="24px" />
              </div>

              <div v-if="displayFlag == 1" class="pl-2 float-right margin-r-10">
                <i class="fa fa-print cursor-pointer pt-0 font-30" aria-hidden="true" @click="printFunc()" ></i>
              </div>
              <div v-if="displayFlag == 1" class="margin-t-2 float-right pl-2 mr-2" @click="downloadFunc()">
                <img class="cursor-pointer" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px"  />
              </div>
              <div class="clear"></div>
            </div>
          </div>

        <div class="row " v-if="loading == true">
            <div class="col-5 pl-0 text-left">
              <div class="row" v-for="option in 3">
                <div class="col-6 padding-r-25">
                <PuSkeleton :count="1" width=""></PuSkeleton>
                </div>
                <div class="col-6 padding-l-25">
                <PuSkeleton :count="1" width=""></PuSkeleton>
                </div>
              </div> 
            </div>
            <div class="col-3 pl-0">
            </div>
            <div class="col-4 pl-0 pr-0">
              <PuSkeleton :count="1"></PuSkeleton>
            </div>
        </div>

        <div class="text-center pt-5" v-if="loading == true">
          <div class="row" v-for="option in 5">
            <div class="field_1 p-0"><PuSkeleton :count="1"></PuSkeleton></div>
            <div class="field_1"><PuSkeleton :count="1"></PuSkeleton></div>
            <div class="field_1"><PuSkeleton :count="1"></PuSkeleton></div>
            <div class="field_1"><PuSkeleton :count="1"></PuSkeleton></div>
            <div class="field_1"><PuSkeleton :count="1"></PuSkeleton></div>
            <div class="col-12 p-0">
              <div class="custom_hr"></div>
            </div>
          </div>
        </div>


        <div class="row" v-if="loading == false">
          <div class="col-md-12">
              <div class="row col-12 override-padding pb-2" style="border-color: #ced4da !important;">
                <div class="col-6 pl-0">
                  <div class="col-12 p-0">
                    <div class="row">
                      <div class="col-6">
                        <b>Start Date:</b> {{ pathwayStartDate }}
                      </div>
                      <div class="col-6">
                        <b>Pathway:</b> {{ pathwayName }}
                      </div>
                    </div>
                    <div class="row pt-2">
                      <div class="col-6">
                        <b>Pathway Duration:</b> {{ pathwayDuration }}
                      </div>
                      <div class="col-6">
                        <b>Current Pathway Step:</b> {{ currentStepName }}
                      </div>
                    </div>
                    <div class="row pt-2">
                      <div class="col-6">
                        <b>Current Step Duration:</b> {{ stepDuration }}
                      </div>
                      <div class="col-6">
                        <b>Steps Remaining:</b> {{ stepRemaining }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-4 pl-0">
                  <span class="cp-filter-label pr-2">Select Objective:</span>
                  <b-form-select v-model="objectiveId" :options="objective_options" class="col-8 margin-b-10 b-r-15" @change="fetchListitems()" />
                </div>
                <div class="col-2 pr-0 text-left search-icon-wrapper cursor-pointer">
                  <button type="button" class="px-4 btn ma-blue-btn btn-md font-weight-bold rounded-pill" @click="fetchListitems()">Filter</button>
                </div>
              </div>

          </div>
        </div>          


          <div class="margin-t-30" v-if="courses.length > 0">
            <div class="row col-12 p-0 report_heading" v-if="loading == false">
              <div class="cfield_1">Course Name</div>
              <div class="cfield_2">Pathway Step</div>
              <div class="cfield_3">Status</div>
              <div class="cfield_4">Score</div>
              <div class="cfield_5">Completion Date</div>
              <div class="cfield_6">Certificate</div>
              
              <div class="col-12 p-0">
                <div class="custom_heading_hr"></div>
              </div>
            </div>


            <div class="row col-12 p-0 report_view" v-for="(course, cindex) in courses" :key="cindex">
              <div class="cfield_1">{{ course.courseName }}</div>
              <div class="cfield_2">{{ course.stepName }}</div>
              <div class="cfield_3">{{ course.status }}</div>
              <div class="cfield_4">{{ course.score }}</div>
              <div class="cfield_5">{{ course.completionDate }}</div>
              <div class="cfield_6 branding_text_color" v-if="(course.status == 'Completed' && course.type == 'Internal')"  @click="viewCourseReport(course.certLink)">View Certificate</div>
              <div class="cfield_6 branding_text_color" v-else-if="(course.status == 'Completed' && course.type == 'External')" @click="viewExternalCourseReport(course.certLink)">View Certificate</div>
              <div class="cfield_6 branding_text_color" v-else>-</div>
              <div class="col-12 p-0">
                <div class="custom_hr"></div>
              </div>
            </div>
          </div>



          <div class="margin-t-30" v-if="assessments.length > 0">
            <div class="row col-12 p-0 report_heading" v-if="loading == false">
              <div class="cfield_1">Assessment Name</div>
              <div class="cfield_2">Pathway Step</div>
              <div class="cfield_3">Status</div>
              <div class="cfield_4">Score</div>
              <div class="cfield_5">Completion Date</div>
              <div class="cfield_6">Results</div>
              
              <div class="col-12 p-0">
                <div class="custom_heading_hr"></div>
              </div>
            </div>


            <div class="row col-12 p-0 report_view" v-for="(assessment, aindex) in assessments" :key="aindex">
              <div class="cfield_1">{{ assessment.assessmentName }}</div>
              <div class="cfield_2">{{ assessment.stepName }}</div>
              <div class="cfield_3">{{ assessment.status }}</div>
              <div class="cfield_4">{{ assessment.score }}</div>
              <div class="cfield_5">{{ assessment.completionDate }}</div>
              <div class="cfield_6 branding_text_color" v-if="assessment.status == 'Completed'" @click="viewAssessmentReport(assessment.userAssessmentAttemptId)">Assessment Results</div>
              <div class="cfield_6 branding_text_color" v-else>-</div>
              <div class="col-12 p-0">
                <div class="custom_hr"></div>
              </div>
            </div>
          </div>

          <div class="margin-t-30" v-if="skills.length > 0">
            <div class="row col-12 p-0 report_heading" v-if="loading == false">
              <div class="tfield_1">Skills Sets</div>
              <div class="tfield_2">Pathway Step</div>
              <div class="tfield_3">Passed (Competent)</div>
              <div class="tfield_4">Highest Rating</div>
              <div class="tfield_5"># of Reps</div>
              <div class="tfield_6">Mentor(s)</div>
              <div class="tfield_7">Latest Mentor Comment</div>
              
              <div class="col-12 p-0">
                <div class="custom_heading_hr"></div>
              </div>
            </div>


            <div class="row col-12 p-0 report_view" v-for="(skill, sindex) in skills" :key="sindex">
              <div class="tfield_1 mentee-first-icon branding_text_color">
                <b-link
                  v-b-toggle="'mentee-first-' + skill.id" @click="getFontIcon(skill.id, sindex)" variant="primary" class="font-color-00acee">
                <i class="fa fa-chevron-right" :id="'angle-'+ skill.id" aria-hidden="true"></i>
                {{ skill.name }}
                </b-link>
              </div>
              <div class="tfield_2">{{ skill.stepName }}</div>
              <div class="tfield_3" v-if="skill.subtaskCompetentPercent == 100">Yes</div>
              <div class="tfield_3" v-else>No</div>
              <div class="tfield_4">{{ skill.rating }}</div>
              <div class="tfield_5">{{ skill.totalReps }}</div>
              <div class="tfield_6">{{ skill.mentors }}</div>
              <div class="tfield_7 tasklist-comment">{{ skill.comment }}</div>
              <div class="col-12 p-0">
                <div class="custom_hr"></div>
              </div>
              <b-collapse v-bind:id="'mentee-first-' + skill.id" class="col-12 mentee-first-collapse" >
              <b-card>
              <div class="bold font-13 mt-3">
                <div v-show="skill.loading" class="loading_show" ><div class="spinner-border text-danger"></div></div>

                <div class="row col-12 p-0 report_view font-normal" v-for="(task, sindex) in skill.tasks" :key="sindex"  >
                  <div class="tfield_1" style="width: 35% !important;">{{ task.description }}</div>
                  <div class="tfield_3" v-if="task.completed == 1">Yes</div>
                  <div class="tfield_3" v-else>No</div>
                  <div class="tfield_4">{{ task.rating }}</div>
                  <div class="tfield_5">{{ task.totalReps }}</div>
                  <div class="tfield_6">&nbsp;</div>
                  <div class="tfield_7 tasklist-comment">{{ task.comment }}</div>
                  <div class="col-12 p-0">
                    <div class="custom_hr"></div>
                  </div>
                </div>
                <div v-if="skill.tasks.length == 0 && skill.loading == false" class="col-12 float-left p-0 text-center">
                  No Tasks found!
                </div>

              </div>
              </b-card>
              </b-collapse>


            </div>
          </div>



          <div class="margin-t-30" v-if="certificates.length > 0">
            <div class="row col-12 p-0 report_heading" v-if="loading == false">
              <div class="tfield_1">Certification</div>
              <div class="tfield_2">Pathway Step</div>
              <div class="tfield_3">Certifying Organization</div>
              <div class="tfield_4">Issued Date</div>
              <div class="tfield_5">Expiration Date</div>
              <div class="tfield_6">Verification ID</div>
              <div class="tfield_7">View Certificate</div>
              
              <div class="col-12 p-0">
                <div class="custom_heading_hr"></div>
              </div>
            </div>


            <div class="row col-12 p-0 report_view" v-for="(certificate, sindex) in certificates" :key="sindex">
              <div class="tfield_1">{{ certificate.certificateName }}</div>
              <div class="tfield_2">{{ certificate.stepName }}</div>
              <div class="tfield_3">{{ certificate.certificateOrg }}</div>
              <div class="tfield_4">{{ certificate.issueDate }}</div>
              <div class="tfield_5">{{ certificate.expirationDate }}</div>
              <div class="tfield_6">{{ certificate.verificationCode }}</div>
              <div class="tfield_7 branding_text_color" v-if="certificate.fileName != ''" @click="viewCertificateReport(certificate.fileName)">View Certificate</div>
              <div class="tfield_7 branding_text_color" v-else>-</div>
              <div class="col-12 p-0">
                <div class="custom_hr"></div>
              </div>
            </div>
          </div>






        </div>
      </div>
    </div>

    <ShareReportModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Share Report</h3></div>
      <div slot="body">
        <div v-if="showShareSuccess == true" class="col-12 override-padding success_msg">
          <b>Report shared successfully!</b>
        </div>
        <div class="col-12 override-padding">
          <input v-model="share_email"
                name="share_email"
                placeholder="Enter Email..."
                class="col-lg-12 input-text form-control input-height-30"
                v-validate="'required|email'"
                data-vv-as="Email address"
                maxlength="255"
                @keyup="checkEmail()" />
         <div v-show="verrors.has('share_email')" class="validate-warning-msg">{{ verrors.first('share_email') }}</div>
        </div>
        <div class="clear margin-bottom-10"></div>


        <!-- <div v-if="showWait == false" class="col-12 override-padding text-align-right">
          <button
              v-on:click="shareButtonSubmit()"
              class="btn btn-dard-grey col-lg-3"
              ><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
          <button
              
              class="btn btn-dard-grey col-lg-3"
              ><b>Please wait...</b></button>
        </div> -->

        <div v-if="showWait == false" class="col-12 override-padding text-align-right">
            <button :disabled="share_button_disable" v-on:click="shareButtonSubmit()"
                class="btn btn-red col-3 input-height-25 createBtn"
                ><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
            <button disabled="true" class="btn btn-dard-grey col-lg-3"
                ><b>Please wait...</b></button>
        </div>

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ShareReportModal>

    <BatchModal :isModalVisible="isExportModalVisible" @close="isExportModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"></div>
      <div slot="body">
        <div class="">
          <div class="export-details">
            Exported: {{ rowsExportedCSV }} of {{ rowsCSV}}
          </div>
          <div class="percentage-text">
            {{ percentage }}
          </div>
          <div class="batch-box">
            <div class="batch-loading" id="batch-loading" >
              &nbsp;
            </div>
          </div>
          <div class="download-link" @click="downloadFunc()" v-if="percentage == '100%'">
            Download CSV File
          </div>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding"></div>
    </BatchModal>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import router from '../../router/index.js';
import { store } from '../../store/store';
// import VeeValidate from 'vee-validate';
import UserMenu from '../shared/user_menu.vue';
import ShareReportModal from '../enterpriseadmin/share_email_report_modal.vue';
import BatchModal from '../admin/reports/report_loading_modal.vue';
import { checkIsManager, checkIsMentor } from '@/components/shared/utils.js';
import EnterprieSidebarMenu from '@/components/shared/enterpriseadmin_sidebar_menu.vue';

// Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  components: {
    UserMenu,
    EnterprieSidebarMenu,
    ShareReportModal,
    BatchModal,
  },
  data() {
    return {
      loading: false,
      showOverlay: false,
      results: [],
      apiUrl: '',
      isModalVisible: false,

      submit_text: 'Submit',
      share_email: '',
      showOverlay: false,
      showWait: false,
      showShareSuccess: false,
      isExportModalVisible: false,
      percentage: '0%',
      fileName: '',
      totalCSVPages: 0,
      perCSVPage: 500,
      rowsCSV: 0,
      rowsExportedCSV: 0,
      currentCSVPage: 1,
      share_button_disable: true,
      pathway_options: [],
      pathwayId: '',
      accountId: '',
      stepCount: 0,
      stepWidth: 0,
      message: '',
      steps: [],
      pdf_file_name: '',
      menteeId: '',
      menteeName: '',
      courses: [],
      assessments: [],
      skills: [],
      certificates: [],
      objective_options: [
        { value: 'All', text: 'All' },
        { value: 'Courses', text: 'Courses' },
        { value: 'Assessments', text: 'Assessments' },
        { value: 'Skills', text: 'Skills' },
        { value: 'Certifications', text: 'Certifications' }
      ],
      objectiveId: 'All',
      currentStepName: '',
      pathwayDuration: '',
      stepDuration: '',
      stepRemaining: '',
      pathwayStartDate: '',
      displayFlag: 0,
      pathwayName: '',
    }
  },
  methods: {
    backtoPathwayProgress() {
      let routeData = this.$router.resolve({path: '/enterpriseadmin/pathway-progress-menteelists/' + this.pathwayId});
      window.open(routeData.href, '_self');
    },
    viewExternalCourseReport: function(fileName) {
      this.apiUrl = process.env.API_ENDPOINT;
      var url = this.apiUrl + '/web/course_certificates/' + fileName;
      window.open(url, '_blank');
      return false;    
    },
    viewCertificateReport: function(fileName) {
      this.apiUrl = process.env.API_ENDPOINT;
      var url = this.apiUrl + '/web/certificates/' + fileName;
      window.open(url, '_blank');
      return false;    
    },
    viewCourseReport: function(url) {
        window.open(url, '_blank');
    },
    viewAssessmentReport: function(id) {
       let routeData = this.$router.resolve({name: 'assessmentreportnew', params: {assessmentAttemptId: id}});
        window.open(routeData.href, '_blank');
    },
    getFontIcon(id, index) {
      if (document.getElementById('mentee-first-' + id).style.display == "") {
        document.getElementById('angle-'+ id).className = "fa fa-chevron-right";
        this.skills[index].loading = false;
        this.skills[index].tasks = [];
      } else {
        document.getElementById('angle-'+ id).className = "fa fa-chevron-down";
        this.skills[index].loading = true;
        this.skills[index].tasks = [];
        this.fetchTasksListitems(index);
      }
    },
    checkEmail: function () {
      if ((this.verrors.items.length === 0)) {
        this.share_button_disable = false;
      }
      else {
        this.share_button_disable = true;
      }
    },
    checkIsMentor() {
      return checkIsMentor();
    },
    checkIsManager() {
      return checkIsManager();
    },
    fetchTasksListitems(index) {
      axios('/desktop/v2/manager/account_pathway_detail_tasklists_report', {
        method: 'GET',
        params: {
          account_id: this.accountId, 
          mentee_id: this.menteeId, 
          tasklists_id: this.skills[index].tasklistId,
        }
      })
      .then(response =>  {
          this.skills[index].loading = false;
          this.skills[index].tasks = response.data.tasks;
      })
      .catch(function() { });
    },
    fetchListitems() {
      this.loading = true;
      this.message = '';
      this.courses = [];
      this.assessments = [];
      this.skills = [];
      this.certificates = [];
      axios('/desktop/v2/manager/account_pathway_detail_report', {
        method: 'GET',
        params: {
          account_id: this.accountId, 
          mentee_id: this.menteeId, 
          pathway_id: this.pathwayId,
          filter: this.objectiveId,
        }
      })
      .then(response =>  {
          this.loading = false;
          this.results = response.data.data;
          this.menteeName = response.data.menteeName;
          this.displayFlag = 0;
          this.courses = response.data.courses;
          this.assessments = response.data.assessments;
          this.skills = response.data.skills;
          this.certificates = response.data.certificates;
          if((this.courses.length > 0) || (this.assessments.length > 0) || (this.skills.length > 0) || (this.certificates.length > 0)) {
            this.displayFlag = 1;
          }
          this.currentStepName = response.data.currentStepName;
          this.pathwayDuration = response.data.pathwayDuration;
          this.stepDuration = response.data.stepDuration;
          this.stepRemaining = response.data.stepRemaining;
          this.pathwayStartDate = response.data.pathwayStartDate;
          this.pathwayName = response.data.pathwayName;
      })
      .catch(function() { });
    },

    downloadFunc: function() {

      this.showOverlay = true;
      axios('/desktop/v2/manager/account_pathway_detail_pdf_report', {
        method: 'GET',
        params: {
          account_id: this.accountId, 
          mentee_id: this.menteeId, 
          pathway_id: this.pathwayId,
          filter: this.objectiveId,
        }
      })
      .then(response =>  {
          this.pdf_file_name = response.data.pdf_file_name;
          this.showOverlay = false;
          var url = this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name;
     
          //Create XMLHTTP Request.
          var req = new XMLHttpRequest();
          req.open("GET", url, true);
          req.responseType = "blob";
          req.onload = function () {
              //Convert the Byte Data to BLOB object.
              var blob = new Blob([req.response], { type: "application/octetstream" });

              //Check the Browser type and download the File.
              var isIE = false || !!document.documentMode;
              if (isIE) {
                  window.navigator.msSaveBlob(blob, fileName);
              } else {
                  var url = window.URL || window.webkitURL;
                  var link = url.createObjectURL(blob);
                  var a = document.createElement("a");
                  a.setAttribute("download", "progress_detail_report.pdf");
                  a.setAttribute("href", link);
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
              }
          };
          req.send();
          return false;
        })
        .catch(function(error) {
            console.log(error);
        });


    },
    printFunc: function() {
      axios('/desktop/v2/manager/account_pathway_detail_pdf_report', {
        method: 'GET',
        params: {
          account_id: this.accountId, 
          mentee_id: this.menteeId, 
          pathway_id: this.pathwayId,
          filter: this.objectiveId,
        }
      })
      .then(res =>  {
          this.pdf_file_name = res.data.pdf_file_name;
          this.showOverlay = false;
          fetch(this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name).then(function(response) {
              return response.blob();
          }).then(function(myBlob) {
              var objectURL = URL.createObjectURL(myBlob);
              document.querySelector('#pdf-frame').src = '';
              document.querySelector('#pdf-frame').src = objectURL;
              objectURL = URL.revokeObjectURL(myBlob);
          }).then(
              function() {
                  window.setTimeout(function() {
                      document.querySelector('#pdf-frame').contentWindow.print();
                  }, 1000)
              });
            return false;
        })
        .catch(function(error) {
            console.log(error);
        });
    },


            shareButtonSubmit: function() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                  this.submit_text = 'Please wait...';
                  this.showWait = true;
                  axios('/desktop/v2/manager/account_pathway_detail_pdf_email_report',
                     {
                       method: 'POST',
                       data:
                        {
                          email: this.share_email,
                          account_id: this.accountId, 
                          mentee_id: this.menteeId, 
                          pathway_id: this.pathwayId,
                          filter: this.objectiveId,
                        },
                     }
                   )
                  .then((resp) => {
                    this.share_email = '';
                    this.submit_text = 'Submit';
                    this.showWait = false;
                    this.showShareSuccess = true;
                    setTimeout(() => {
                        this.showShareSuccess = false;
                    }, 5000)
                    //this.isModalVisible = false;
                    //this.$emit('close');

                   })
                  .catch(error => {

                  });
                }
              });

            },
    shareButtonModal() {
      this.isModalVisible = true;
    },
  },
  created() {
    this.loading = true;
    this.message = '';
    this.apiUrl = process.env.API_ENDPOINT;
    this.menteeId = this.$route.params.mentee_id;
    this.pathwayId = this.$route.params.pathway_id;
    this.accountId = this.$route.params.account_id;
    this.fetchListitems();



  }
}
</script>

<style scoped>
.report_heading {   
    font-size: 14px; 
    padding-top: 8px;
    padding-bottom: 8px;
    font-weight: bold;
}
.custom_heading_hr, .custom_hr {
  width: 100%;
  margin: 5px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.custom_heading_hr {
    border-bottom: 3px solid #A3A3A3;
}
.tfield_1, .tfield_7 {
  width: 20%;
  padding-left: 15px;
}
.tfield_2, .tfield_3 {
  width: 15%;
  padding-left: 15px;
}
.tfield_4, .tfield_5 {
  width: 9%;
  padding-left: 15px;
}
.tfield_6 {
  width: 12%;
  padding-left: 15px;
}
.cfield_1, .cfield_2, .cfield_6 {
  width: 20%;
  padding-left: 15px;
}
.cfield_1, .tfield_1 {
  padding-left: 0px;
}
.cfield_2 {
  width: 21%;
}
.cfield_3, .cfield_4, .cfield_5 {
  width: 13%;
  text-align: left;
}
.field_9 {
  width: 11%;
  text-align: right;
  padding-right: 15px;
}
.btn:disabled {
    background-color: #8b8b8b;
    color: #FFF;
}
.report_view {
  min-height: 40px;
  font-weight: bold;
}
.report_view .field_1 {
  cursor: pointer;
}
.mentee-first-icon .fa-chevron-down, .mentee-first-icon .fa-chevron-right {
  font-size: 14px !important;
}
.overlay {
  opacity: .9
}
.report_view .cfield_6, .report_view .tfield_7 {
  cursor: pointer;
}
.report_view .tasklist-comment {
  color: #002F42; cursor: default;
}
.font-30 {
  font-size: 30px;
}
.field_1 {
  width: 20%; padding-left: 15px;
}
.success_msg {
  color: #68C47E; text-align: center; margin-bottom: 15px;
}
.btn-dard-grey, .btn-dard-red {
  line-height: 30px; border-radius: 10px;  
}
.loading_show {
  float: none; height: 80px; text-align: center;
}
.font-normal {
  font-weight: normal;
}
.back_icon { width: 13px !important; }
#sidebar1 {
  min-width: 165px;
  max-width: 165px;
  background-color: #FFFFFF;
  min-height: 100vh;
  transition: opacity 2s linear;
  transform: translate(0);
  opacity: 1;
  padding-top: 75px;
  position: fixed;
}

@media (max-width: 1199.98px) {
  #sidebar1 {
    min-width: 145px;
    max-width: 145px;
  }
}
#sidebar1 ul li {
  padding: 0px 10px 0px 10px;
  display: block;
  color: #6c757d !important;
  margin-left: 5px;
}

.sidebar_view_mentee {
  min-width: 110px !important;
}


</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/pathway_progress_report_detail.vue